import Model from "flarum/Model";

export default class U2DiInfoDistributes extends Model {}
Object.assign(U2DiInfoDistributes.prototype, {
  id: Model.attribute("id"),
  base_id: Model.attribute("base_id"),
  user_id: Model.attribute("user_id"),
  userType: Model.attribute("userType"),
  sn: Model.attribute("sn"),
  nID: Model.attribute("nid"),
  lat: Model.attribute("lat"),
  lng: Model.attribute("lng"),
  note: Model.attribute("note"),
  fxxx: Model.attribute("fxxx"),
  ratio_owner: Model.attribute("ratio_owner"),
  ratio_plaform: Model.attribute("ratio_plaform"),
  ratio_distributor: Model.attribute("ratio_distributor"),
  ratio_buyer: Model.attribute("ratio_buyer"),
  nID: Model.attribute("nid"),
  assignedAt: Model.attribute("assignedAt"),
  u2diDetailsData: Model.hasOne("u2diDetailsData"),
  u2diBaseData: Model.hasOne("u2diBaseData"),
  u2diUserData: Model.hasOne("u2diUserData"),
  u2diReportData: Model.hasMany("u2diReportData"),
});